export default __webpack_public_path__ + "static/media/main-rye.94ea96d2.png";